var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiCopy = function SvgAiCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.5 12.5c0-2.357 0-3.536.732-4.268S10.143 7.5 12.5 7.5h.833c2.357 0 3.536 0 4.268.732s.732 1.911.732 4.268v.833c0 2.357 0 3.536-.732 4.268s-1.91.732-4.268.732H12.5c-2.357 0-3.536 0-4.268-.732s-.732-1.91-.732-4.268z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.168 7.501c-.002-2.464-.04-3.74-.757-4.614a3.3 3.3 0 0 0-.462-.462c-.922-.757-2.291-.757-5.031-.757s-4.11 0-5.031.757a3.3 3.3 0 0 0-.462.462c-.757.922-.757 2.291-.757 5.031s0 4.11.757 5.031q.208.255.462.462c.874.718 2.15.755 4.614.757"
  })));
};
export default SvgAiCopy;